// Third-party
import React from 'react';
import Dotdotdot from 'react-dotdotdot';

// Utils
import { formatLocalizedString, formatMessage } from '../../../../utils/i18n';

// Components
import { HoldingIcon } from '../../common';
import { Checkbox } from '../../inputs';
import LocalizedString from '@/types/localized-string';
import ComparisonItemType from '@/types/comparison-item-type';

export type ProposalItemDragPreviewItem = {
  _id: string;
  name: LocalizedString;
  type: ComparisonItemType;
  color?: string;
  disabled: boolean;
  selected: boolean;
};

type Props = {
  item: ProposalItemDragPreviewItem;
};

const ProposalItemDragPreview = (props: Props) => (
  <div className="proposal-item-drag-preview">
    <Checkbox selected={props.item.selected} aria-label={formatMessage('Common.Accessibility.SelectItem', { item: formatLocalizedString(props.item.name) })} />

    {props.item.color && <HoldingIcon type={props.item.type} color={props.item.color} />}

    <Dotdotdot useNativeClamp clamp={2}>
      {formatLocalizedString(props.item.name)}
    </Dotdotdot>
  </div>
);

export default ProposalItemDragPreview;
